import { createContext } from 'react'

export const BuilderContext = createContext(null)
